import { useEffect, useState } from "react";
import { Eye, Send } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export const WelcomePanel = () => {
  const [d, setD] = useState(null);
  const [html, setHtml] = useState("");
  const load = () => api.get("/admin/welcome").then((r) => setD(r.data));
  useEffect(() => { load(); }, []);
  const preview = async () => {
    try { setHtml((await api.get("/admin/welcome/preview", { responseType: "text" })).data); } catch (e) { toast.error(formatApiError(e)); }
  };
  const send = async () => {
    if (!window.confirm(`Send the welcome email to ${d.pending} people now?`)) return;
    try { await api.post("/admin/welcome/send"); toast.success("Sending started"); setTimeout(load, 5000); } catch (e) { toast.error(formatApiError(e)); }
  };
  if (!d) return null;
  return (
    <div className="bg-white border border-[#E7E7E7] p-6" data-testid="welcome-panel">
      <p className="font-display text-lg font-bold">Welcome email</p>
      <p className="text-xs text-[#575757] mt-1">Each new newsletter subscriber or Origin Cup contact gets one welcome introducing Africa Brew Brief and The Origin Cup. Website sign-ups get it straight away; imported contacts are picked up every hour.</p>
      <p className="text-sm mt-3" data-testid="welcome-counts">{d.sent} welcomed · {d.pending} waiting{d.failed ? ` · ${d.failed} failed` : ""}</p>
      <div className="flex gap-2 mt-4">
        <button onClick={preview} data-testid="welcome-preview-btn" className="flex items-center gap-2 border border-[#0A0A0A] px-3 h-9 text-sm"><Eye size={14} /> Preview</button>
        <button onClick={send} disabled={!d.pending} data-testid="welcome-send-btn" className="flex items-center gap-2 bg-[#E5332A] text-white px-3 h-9 text-sm disabled:opacity-40"><Send size={14} /> Send to {d.pending} waiting now</button>
      </div>
      {html && (
        <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" onClick={() => setHtml("")} data-testid="welcome-preview-overlay">
          <div className="bg-white w-full max-w-[700px] h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
            <div className="flex justify-between items-center px-4 py-2 border-b border-[#E7E7E7]"><span className="text-sm font-bold">Welcome email preview</span>
              <button onClick={() => setHtml("")} data-testid="welcome-preview-close" className="text-sm underline">Close</button></div>
            <iframe title="Welcome preview" srcDoc={html} sandbox="" className="w-full flex-1" data-testid="welcome-preview" />
          </div>
        </div>
      )}
    </div>
  );
};
